import { styled, Box, TextV1 } from '@withjoy/joykit';
import { backgroundImageForUrl } from '@shared/utils/style/backgroundImage';

export const StyledEmptyCategoryImage = styled(Box)<{ photoUrl: string }>`
  background-image: ${props => backgroundImageForUrl(props.photoUrl)};
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  box-sizing: border-box;
`;

export const StyledSubtitleText = styled(TextV1)`
  max-width: 400px;
`;
